<template>
	<div class="productWord">
		<div class="data_left">
			<div class="data_title">选定产品关键词（当前选定{{ keywordsList.length }}个）
				<div class="manual_input">
					<el-input v-model="input" @keyup.enter.native="enterInput" placeholder="+手动输入关键词（回车确认）">
						<i slot="suffix" class="suffix" @click="dialogVisible = true">关键词助手</i>
					</el-input>
					<el-dialog :close-on-click-modal="false" title="批量添加关键词" :visible.sync="dialogVisible">
						<el-input :autosize="{ minRows: 8, maxRows: 11}" type="textarea" placeholder="批量添加关键词，每行一个；如需链接，可在关键词后添加"
							v-model="textarea" @focus="SecondVerifica">
						</el-input>
						<div v-if="abnormal" class="item_error">部分链接不完整或非客户网站，已置顶，修改后重新校验</div>
						<div v-if="special" class="item_error">关键词仅允许+ - : . &等5种特殊字符</div>
						<div class="item_words" v-show="false" @click="ChangeDialog">拓展更多关键词</div>
						<span slot="footer" class="dialog-footer">
							<el-button @click="dialogVisible = false">取 消</el-button>
							<el-button v-if="buttonFlag" type="primary" @click="keywordCheck">校验</el-button>
							<el-button v-else type="primary" @click="batchAdd">保存</el-button>
						</span>
					</el-dialog>
					<keywordsAssistant v-bind="$attrs" :domain="domain" :keywordsList="keywordsList" :dialogVisible="assistantDialog" :textarea="textWords" @extentWords="extentWords" @addExtension="addExtension"></keywordsAssistant>
				</div>
			</div>
			<div class="data_left_list" v-loading="load">
				<div style="padding: 7px 15px 7px 12px; font-weight: 600">
					<div class="left_keywords">
						<el-row style="text-align:center">
							<el-col :span="5">
								<div style="text-align:left">关键词</div>
							</el-col>
							<el-col :span="5">
								<div> 匹配方式 </div>
								<el-dropdown @command="changeMode">
									<span class="el-dropdown-link">
										{{ matchMode }}<i class="el-icon-arrow-down el-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item v-for="items in matchTypes" :command="items.code" :key="items.name">{{ items.name }}</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</el-col>
							<el-col :span="5">
								<div> 平均每月搜索量 </div>
							</el-col>
							<el-col :span="5">
								<div> 竞争程度 </div>
							</el-col>
							<el-col :span="4">
								<div> 操作 </div>
							</el-col>
						</el-row>
					</div>
				</div>
				<div class="left_item">
					<div class="data_left_item" v-for="(item, index) in keywordsList" :key="index">
						<div class="left_keywords">
							<el-row style="text-align:center">
								<el-col :span="5">
									<div style="display:flex;align-items:baseline">
										<el-tag v-if="item.handMovement == ''" style="margin-right:5px;" size="mini">手动</el-tag>
										<ig-icon v-if="item.keywordLink" name="lianjie" style="margin-right:5px; color:#3DA1FF;cursor: pointer;" @click="jumpLink(item.keywordLink)"></ig-icon>
										<span :class="{spantext:item.keywordLink}"
											style="text-align:left;overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
											{{item.keyword | enterTypes(item) }}
										</span>
									</div>
								</el-col>
								<el-col :span="5">
									<!-- <div> {{ item['匹配方式'] || '-'}} </div> -->
									<el-select v-model="item.enterType" placeholder="请选择：" size="mini">
										<el-option
											v-for="items in matchTypes"
											:key="items.name"
											:label="items.name"
											:value="items.code">
										</el-option>
									</el-select>
								</el-col>
								<el-col :span="5">
									<div> {{ item.searchNum || '-'}} </div>
								</el-col>
								<el-col :span="5">
									<div> {{ item.compete || '-'}} </div>
								</el-col>
								<el-col :span="4">
									<div>
										<el-link style="text-align:right" :underline="false" type="primary" @click="openLinkDialog(item)">添加链接</el-link>
										<el-link style="text-align:right" :underline="false" type="primary" @click="add(item, index)">我不需要</el-link>
										<i class="el-icon-close el-tag__del" @click="del(index)"></i>
									</div>
								</el-col>
							</el-row>
						</div>
					</div>
					<el-dialog :close-on-click-modal="false" :title="selectval.keyword" :visible.sync="linkDialog" width="30%">
						<div class="linkword">链接</div>
						<el-form ref="form" :rules="rules" :model="form">
							<el-form-item prop="kwLink">
								<el-input v-model="form.kwLink"></el-input>
							</el-form-item>
						</el-form>
						<span slot="footer" class="dialog-footer">
							<el-button @click="linkDialog = false">取 消</el-button>
							<el-button type="primary" @click="saveLink">保 存</el-button>
						</span>
					</el-dialog>
				</div>
			</div>
		</div>
		<div class="data_right">
			<div class="data_title">
				<i v-if="flag" @click="retractRelease" class="el-icon-caret-top" style="cursor: pointer;"></i>
				<i v-else @click="retractRelease" class="el-icon-caret-bottom" style="cursor: pointer;"></i>
				我不需要投放广告的产品词（当前否定{{ excludedKeywordsList.length }}个）
			</div>
			<div class="right_item" v-if="flag">
				<div class="data_right_list" v-loading="load" v-if="excludedKeywordsList.length">
					<div class="data_right_item" v-for="(item, index) in excludedKeywordsList" :key="index">
						<div class="right_keywords">
							<el-row style="text-align:center">
									<el-col :span="5">
										<div style="display:flex;align-items:baseline">
											<el-tag v-if="item.handMovement == ''" style="margin-right:5px;"  size="mini">手动</el-tag>
											<ig-icon v-if="item.keywordLink" name="lianjie" style="margin-right: 5px;color:#3DA1FF;cursor: pointer;" @click="jumpLink(item.keywordLink)"></ig-icon>
											<span :class="{spantext:item.keywordLink}"
												style="text-align:left;overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
												{{item.keyword | enterTypes(item) }}
											</span>
										</div>
									</el-col>
									<el-col :span="5">
										<el-select v-model="item.enterType" placeholder="请选择：" size="mini">
											<el-option
												v-for="items in matchTypes"
												:key="items.name"
												:label="items.name"
												:value="items.code">
											</el-option>
										</el-select>
									</el-col>
									<el-col :span="5">
										<div> {{ item.searchNum || '-'}} </div>
									</el-col>
									<el-col :span="5">
										<div> {{ item.compete || '-'}} </div>
									</el-col>
									<el-col :span="4" style="text-align:right">
										<el-link style="text-align:right" :underline="false" type="primary" @click="remove(item, index)">我需要</el-link>
										<i class="el-icon-close el-tag__close" @click="delExcluded(index)"></i>
									</el-col>
								</el-row>
						</div>
					</div>
				</div>
				<div class="data-empty" v-else>
					<img class="img" src="https://img.iglobalwin.com/nodata.png" />
					<div class="hint">暂无数据</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import keywordsAssistant from '@/components/adsOnlineAuto/com/keywordsAssistant.vue'
// import adsNewOnlineSer from '@/client/services/adsNewOnline/adsNewOnlineSer.js'
import googleads from '@/backend/services/googleAds/googleAds.js';
import { biMap } from '@/utils/index.js'
export default {
	name: 'proKeywords',
	components:{keywordsAssistant},
	props: ["keywordsList", 'excludedKeywordsList', 'load', 'value', 'domain'],
	filters: {
		enterTypes(val,item) {
			if(item.enterType == 'BROAD') {
				// 广泛匹配
				return val;
			}else if(item.enterType == 'PHRASE') {
				// 词组匹配
				return '"'+val+'"'
			}else if(item.enterType == 'EXACT') {
				// 完全匹配
				return '['+val+']'
			}else {
				return val;
			}
		},
	},
	data() {
		var validatePagePath = (rule, value, callback) => {
			let domain = this.domain;
			let reg=/^https:\/\//;
			if(value){
				if (!reg.test(value)||value.search(domain) == -1) {
					callback(new Error('非客户网站'));
				} else {
					callback();
				}
			}else{
				callback();
			}
		};
		return {
			flag: false,
			assistantDialog: false,
			textWords: '',
			input: '',
			dialogVisible: false,
			linkDialog: false,
			textarea: '',
			selectval: {},
			keyHistorical: [],
			form: {
				kwLink: '',
			},
			rules: {
				kwLink: [
					{ required: true,validator: validatePagePath, trigger: 'blur' },
				],
			},
			abnormal: false,
			special: false,
			buttonFlag: true,
			normalList: [],
			verification: [],
			matchTypes: [
				{
					code: 'BROAD',
					name: '广泛匹配'
				},
				{
					code: 'PHRASE',
					name: '词组匹配'
				},
				{
					code: 'EXACT',
					name: '完全匹配'
				},
			], // 关键词匹配方式
			matchMode: '广泛匹配', // 批量修改关键词匹配方式
		};
	},
	watch: {
		// value: {
		// 	handler(val) {
		// 		this.keywordsList = val.keywordsList;
		// 		this.excludedKeywordsList = val.excludedKeywordsList;
		// 	},
		// 	immediate: true,
		// 	deep: true
		// },
		keywordsList: {
			// 值改变触发change
			handler(val) {
				this.keywordsList = val;
				this.change()
			},
			immediate: true,
			deep: true
		},
		excludedKeywordsList: {
			// 值改变触发change
			handler(val) {
				this.excludedKeywordsList = val;
				this.change()
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		// 抛出value值
		change() {
			let res = {
				keyWordDtos: this.keywordsList,
				negativeKeyWords: this.excludedKeywordsList
			}
			this.$emit('change', res);
			this.$emit('input', res);
		},
		async keywordHistorical(paramArr){
			try {
				let res = await googleads.getKeywordHistorical({
					keywords: paramArr
				});
				this.keyHistorical = res.data;
				this.keyHistorical.forEach((item)=>{
					item.handMovement = ''; // 是否手动类型
					this.normalList.forEach((ele)=>{
						if(ele.keyword == item.keyword && ele.keywordLink){
							item.keywordLink = ele.keywordLink;
						}
					})
				});
			} catch (error) {
				console.log(error);
			}
		},
		async keywordCheck(){
			let keywordList = this.textarea.split('\n').map(item=>{return item.replace('\t',' ')}).filter(function (s) {return s && s.trim(); });
				//去除u00A0
			let keywordVal = keywordList.map(item => {
				return item.replace(/\u00A0/g, ' ');
			});
			try {
				let res = await googleads.getKeywordCheck({
					// automationId: this.$route.query.id,
					keywordList: keywordVal,
					// serviceId: this.$route.query.serviceSiteId,
				});
				if(res.data.abnormalList.length){
					this.abnormal = true;
					this.buttonFlag = true;
				}else{
					this.abnormal = false;
					this.buttonFlag = false;
				}
				if(res.data.specialList.length){
					this.special = true;
					this.buttonFlag = true;
				}else{
					this.special = false;
					this.buttonFlag = false;
				}
				this.verification = [];
				res.data.abnormalList.forEach(item=>{
					let a = '';
					if(item.keywordLink){
						a = item.keyword+' '+item.keywordLink;
					}else{
						a = item.keyword
					}
					this.verification.push(a);
				});
				res.data.specialList.forEach(item=>{
					let a = '';
					if(item.keywordLink){
						a = item.keyword+' '+item.keywordLink;
					}else{
						a = item.keyword
					}
					this.verification.push(a);
				});
				(res.data.abnormalList.length || res.data.specialList.length) && this.verification.push(' ');
				res.data.normalList.forEach(item=>{
					let a ='';
					if(item.keywordLink){
						a = item.keyword+' '+item.keywordLink;
					}else{
						a = item.keyword
					}
					this.verification.push(a);
				});
				this.normalList = res.data.normalList;
				this.textarea = this.verification.join('\n');
			} catch (error) {}
		},
		SecondVerifica(){
				this.buttonFlag = true;
		},
		batchAdd() {
			let { excludedKeywordsList, keywordsList } = this;
			this.textarea = '';
			this.keyHistorical = [];
			let inputArr = [];
			let repeatKey = [];
            let paramArr = [];
			this.normalList.forEach((key) => {
			let thereAre = keywordsList.findIndex(item => {
					return item.keyword === key.keyword;
			});
			if (thereAre !== -1) {
					keywordsList[thereAre].keywordLink = key.keywordLink;
					repeatKey.unshift(key);
					return;
			}
			let thereAreExcluded = excludedKeywordsList.findIndex(item => {
					return (item.keyword === key.keyword);
			});
			if (thereAreExcluded !== -1) {
					excludedKeywordsList[thereAreExcluded].keywordLink = key.keywordLink;
					this.remove(excludedKeywordsList[thereAreExcluded], thereAreExcluded);
					return;
			}
			inputArr.unshift(key);
			});
			inputArr.forEach(e => { 
				paramArr.push(e.keyword)
			});
			if(paramArr.length){
				this.keywordHistorical(paramArr).then(async () => {
						this.keywordsList.unshift(...this.keyHistorical);
						this.dialogVisible = false;
						this.buttonFlag = true;
				});
			}else{
				this.dialogVisible = false;
				this.buttonFlag = true;
			}
			let length = this.normalList.length - repeatKey.length;
			this.$message.warning(`${repeatKey.length}个核心产品词已存在,成功添加${length}个`);
		},
		enterInput() {
			let { input: keyword, excludedKeywordsList, keywordsList } = this;
			this.input = '';
			let thereAre = keywordsList.findIndex(item => {
				return item.keyword === keyword;
			});
			if (thereAre !== -1) {
				this.$message.warning('该核心产品词已存在');
				return;
			}
			let thereAreExcluded = excludedKeywordsList.findIndex(item => {
				return item.keyword === keyword;
			});
			if (thereAreExcluded !== -1) {
				this.remove(excludedKeywordsList[thereAreExcluded], thereAreExcluded);
				return;
			}
			if(keyword[0] !== ' ' && keyword !== ''){
				let parameter = [];
				parameter.unshift(keyword);
				this.keywordHistorical(parameter).then(async () => {
					this.keywordsList.unshift(...this.keyHistorical);
				});
			}else{
				this.$message.warning('输入内容不能包含空值');
			}
		},
		openLinkDialog(val){
			this.linkDialog = true;
			this.selectval = val;
			this.form.kwLink = val.keywordLink;
			this.$refs['form'] && this.$refs['form'].clearValidate();
		},
		saveLink(){
			this.$refs['form'].validate((valid) => {
				if (valid) {
					this.selectval.keywordLink = this.form.kwLink;
					this.linkDialog = false;
				} else {
					this.$message.warning('非客户网站，无法保存');
					return false;
				}
			});
		},
		jumpLink(url){
			window.open(url);
		},
		// 添加到 我不需要 列表
		add(val, index) {
			val.enterType = 'EXACT'; // 否定关键词增加匹配方式，默认“完全匹配”
			this.excludedKeywordsList.unshift(val);
			this.keywordsList.splice(index, 1);
		},
		// 删除 我需要列表 当前项
		del(index) {
			this.keywordsList.splice(index, 1);
		},
		// 把当前选中项从 不需要 列表 移到 我需要 列表
		remove(val, index) {
			this.excludedKeywordsList.splice(index, 1);
			this.keywordsList.unshift(val);
		},
		// 删除 我不需要 列表当前项
		delExcluded(index) {
			this.excludedKeywordsList.splice(index, 1);
		},
		ChangeDialog(){
			this.dialogVisible = false;
			this.assistantDialog = true;
			this.textWords = this.textarea.split('\n').map((item)=>{return item.indexOf('https')+1 ?  item.slice(0,item.indexOf('https')) : item}).filter(s=>{return s && s.trim()}).join('\n');
			this.textarea = '';
		},
		extentWords(val){
			this.assistantDialog = val;
		},
		addExtension(val){
			this.keywordsList.unshift(...val);
		},
		getData() {
			let { keywordsList, excludedKeywordsList } = this;
			return {
				keywordsList,
				excludedKeywordsList,
			};
		},
		retractRelease(){
			this.flag = !this.flag;
		},
		// 批量修改关键词匹配方式
		changeMode(val) {
			this.keywordsList.forEach(item => {
				item.enterType = val;
			})
			this.matchMode = biMap(this.matchTypes,'code','name')[val] || '广泛匹配';
		}
	},
};
</script>
<style lang="scss" scoped>
.productWord {
	justify-content: center;
	margin-top: 30px;
	@mixin scrollbar {
		// 改变滚动条样式
		&::-webkit-scrollbar {
			width: 4px;
		}
		&::-webkit-scrollbar-thumb {
			background-color: #e8e8e8;
			border-radius: 6px;
		}
		&::-webkit-scrollbar-track {
			background-color: #fff;
			border-radius: 2px;
		}
	}
	.data_left,
	.data_right {
		width: 90%;
		// margin-left: 40px;
		background: #ffffff;
		border: 1px solid #e3e3e0;
		display: flex;
		flex-direction: column;
	}
	.data_right {
		.right_item {
			height: 350px;
			overflow-y: auto;
			@include scrollbar;
		}
		.data-empty {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			background-color: rgba(255, 255, 255, 0.7);
		}

		.data-empty .img {
			width: 174px;
			height: 140px;
		}

		.data-empty .hint {
			margin-top: 15px;
			font-size: 15px;
			color: #333333;
		}
	}
	.data_title {
		height: 54px;
		background: #fafafa;
		border-bottom: 1px solid #e3e3e0;
		font-size: 14px;
		font-weight: 600;
		color: #333333;
		display: flex;
		align-items: center;
		padding-left: 15px;
	}
	.manual_input {
		margin: 10px;
		width: 500px;
		margin-left: auto;
		.suffix {
			line-height: 40px;
			color: #3DA1FF;
			font-style: normal;
			margin-right: 10px;
			cursor: pointer;
		}
		.item_error{
			color: #F56C6C;
			font-size: 12px;
		}
		.item_words{
			margin: 50px -10px -70px;
			font-size: 14px;
			font-weight: 400;
			color: #3DA1FF;
			cursor: pointer;
		}
	}
	.data_left_list,
	.data_right_list {
		flex: 1;
		color: #333333;
		.left_item {
			height: 310px;
			overflow-y: auto;
			@include scrollbar;
		}
		@include scrollbar;
	}
	.data_left_list {
		.data_left_item {
			// height: 30px;
			padding: 7px 15px 7px 10px;
			font-size: 12px;
			font-weight: 400;
			.el-tag__del {
				margin-left: 10px;
				background: #c0c4cc;
				border-radius: 50%;
				padding: 1px;
				color: #fff;
				cursor: pointer;
				visibility: hidden;
			}

			.el-link {
				font-size: 12px;
				margin-left: 10px;
				visibility: hidden;
			}

			&:hover {
				.el-link,
				.el-tag__del {
					visibility: visible;
				}
			}
		}
		
		.linkword{
				margin-bottom: 15px;
			}
	}
	.data_right_list {
		.data_right_item {
			// height: 30px;
			margin: 5px 10px;
			padding: 5px;
			font-size: 12px;
			font-weight: 400;
			.el-icon-close {
				margin-left: 10px;
				background: #c0c4cc;
				border-radius: 50%;
				padding: 1px;
				color: #fff;
				cursor: pointer;
			}
		}
	}
	.data_right_item,
	.data_left_item {
		cursor: default;
		@mixin text(){
			.spantext{
				color: #3DA1FF  ;
			}
		}
		&:hover {
			@include text;
			background: #f1f8ff;
		}
	}
	::v-deep  .el-dialog__title {
	word-break:break-all;
    width: 380px;
    display: block;
}
}
</style>
